import React from 'react';
import { ZoneLabelProps } from './types';
import { OverlayView } from '@react-google-maps/api';
import { ArcStack } from '@src/core/ui';
import { labelStyle } from './styles';
import { ZoneShapeType } from '@src/core/features/zones/entites';
import { getPolygonCenter } from '@src/core/features/zones/utils';

const ZoneLabel: React.FC<ZoneLabelProps> = (props) => {
  const { zone } = props;
  const lat = Number(zone.centerLatitude);
  const lng = Number(zone.centerLongitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  const position = zone.shape === ZoneShapeType.POLYGON 
    ? getPolygonCenter(zone.polygonCoordinates) 
    : { lat, lng };

  return (
    <OverlayView 
      position={position} 
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <ArcStack sx={labelStyle}>
        {zone.name}
      </ArcStack>
    </OverlayView>
  );
};

export default ZoneLabel;